import React from "react";

const OvertimePolicy = () => {
    return <div>Overtime Policy</div>;
};

export default OvertimePolicy;